import { useEffect } from "react";
import { useHistory } from "react-router-dom";

export default function SWNavigationBridge() {
  const history = useHistory();

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    const handler = (event) => {
      if (event.data?.type === "NAVIGATE") {
        history.push(event.data.payload?.url || "/");
      }
    };

    navigator.serviceWorker.addEventListener("message", handler);
    return () =>
      navigator.serviceWorker.removeEventListener("message", handler);
  }, [history]);

  return null;
}
